import { Component } from "@angular/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";

@Component({
  selector: "app-admin-reminders",
  templateUrl: "./admin-reminders.component.html",
  styleUrls: ["./admin-reminders.component.scss"],
  standalone: false,
})
export class AdminRemindersComponent {
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  constructor() {}
}
